import React from 'react';
import PropTypes from 'prop-types';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMDashboardUserBaloonView from 'components/dashboard/shared/SMDashboardUserBaloonView';

class SMMessageBaloonView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      reservation: this.props.reservation,
      message: this.props.message,
    };
  }
  
  render() {
    let reservation = this.props.reservation,
        message = this.state.message,
        name = SMFormatHelper.messageName(message, reservation);
    let classNames = [
      "dashboard-message-baloon",
      "dashboard-message-baloon__left",
      "dashboard-message-baloon__receive",
    ];
    let link = "";
    let baloonButtonTitle = I18n.t("dashboard.label_000097");
    let baloonButtonLink = "#";
    if (message.from_type == "Owner") {
      link = Routes.owner_path(message.from.username);
      baloonButtonLink = Routes.dashboard_message_path(reservation.uid);
    }
    else if (message.from_type == "User") {
      link = Routes.user_path(message.from.username);
      baloonButtonLink = Routes.owner_dashboard_message_path(reservation.owner.username, reservation.uid);
    }
    else if (message.from_type == 'AdminUser') {
      classNames.push("dashboard-message-baloon__spm");
    }
    
    return (
      <div className="dashboard-message-box">
        <SMDashboardUserBaloonView
          user={reservation.user}
          owner={reservation.owner}
          link={link}
          baloonType={message.from_type}
          baloonData={JSON.stringify(message.from)}
          baloonButtonTitle={baloonButtonTitle}
          baloonButtonLink={baloonButtonLink}
          image={message.from_type == 'AdminUser' ? message.from.image : SMFormatHelper.userImageUrl(message.from, message.from.profile_image)}
          className="js-baloon dashboard-message__icon fl"
          name={name} />
        <p className={classNames.join(" ")}
          dangerouslySetInnerHTML={{__html:SMFormatHelper.messageContent(message)}}>
        </p>
        {SMRenderHelper.renderFileAttachment(message, name)}
      </div>
    );
  }
}

SMMessageBaloonView.propTypes = {
  reservation: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
};
export default SMMessageBaloonView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageBaloonView.jsx